import {getDevice} from "framework7/shared/get-device";
import {FirebaseService} from "@/services/firebase/FirebaseService";
import {DocumentTypes} from "@/services/firebase/firestore/documents/DocumentTypes";
import DocumentOthers from "@/services/firebase/firestore/documents/DocumentOthers";
import ServiceAccount from "@/services/v2/data/service-account/ServiceAccount";

export default class UtilsService {
    private static instance?: UtilsService;
    private _telegramBotSellNotifyUrl = import.meta.env.VITE_TELEGRAM_BOT_SELL_NOTIFY;

    static of() {
        if (typeof UtilsService.instance === 'undefined') UtilsService.instance = new UtilsService();
        return UtilsService.instance;
    }

    setTelegramBotSellNotifyUrl(value: string) {
      this._telegramBotSellNotifyUrl = value;
    }

    async openTelegramSupportChat() {
        const url = this.getSupportLink()

        if (!url) {
            return;
        }

        try {
            if (getDevice().cordova) {
                // @ts-ignore
                window.cordova.InAppBrowser.open(url, '_system');
            } else {
                window.open(url, "_target");
            }
        } catch (e) {
          window.open(url, "_target");
        }
    }

    getSupportLink() {
        let url: string | null = import.meta.env.VITE_TELEGRAM_BOT_SUPPORT;
        let isUseFirebase = import.meta.env.VITE_USE_FIREBASE;

        if (isUseFirebase === 'true' && !FirebaseService.of().isInitialized().value) {
            return null;
        }

        if (isUseFirebase === 'true') {
            const docOthers = FirebaseService.of().firestoreService?.getDocument(DocumentTypes.OTHERS) as DocumentOthers;
            const account = ServiceAccount.of().account;
            if (docOthers) {
                if (account?.value?.currency?.name) {
                    url = docOthers.getSupportLink(account.value.currency.name);
                } else {
                    url = docOthers.getSupportLink('RUB');
                }
            }
        }

        return url;
    }

    async openTelegramWithdrawalSubscribeChat(operationId: number) {
        const url = `${this._telegramBotSellNotifyUrl}?start=${operationId}`;

        try {
            if (getDevice().cordova) {
                // @ts-ignore
                window.cordova.InAppBrowser.open(url, '_system');
            } else {
                window.open(url, "_target");
            }
        } catch (e) {
            window.open(url, "_target");
        }
    }

  currencyFormatter(currency: "RUB" | "USD" | "USDT" | "KZT") {
    const locale = currency === "KZT" ? "ru-KZ" : "ru-RU";
    const realCurrency = currency === "USDT" ? "USD" : currency;

    const formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: realCurrency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    return {
      format(value: number) {
        let formatted = formatter.format(value);
        formatted = formatted.replace(',', '.');

        if (currency === "USDT") {
          return formatted.replace('$', "USDT");
        }
        return formatted;
      }
    };
  }
}
